<template>
  <v-row justify="center" align="center">
    <v-col cols="12">
      <v-banner icon="mdi-tag">
        Order Discounts Maintenance

        <template v-slot:actions>
          <v-btn
            outlined
            color="success"
            :to="{ name: 'MaintenanceOrderdiscountsAdd' }"
          >
            <v-icon left>add_circle_outline</v-icon>
            Add Discount
          </v-btn>
        </template>
      </v-banner>
    </v-col>

    <v-col cols="12">
      <SetFlag />
    </v-col>

    <v-col cols="12">
      <ViewOrderDiscounts />
    </v-col>
  </v-row>
</template> 

<script>
import SetFlag from "@/components/orderDiscounts/SetFlag.vue";
import ViewOrderDiscounts from "@/components/orderDiscounts/View.vue";

export default {
  name: "OrderDiscounts",

  components: {
    SetFlag,
    ViewOrderDiscounts,
  },
};
</script>

<style lang="sass" scoped>
</style>

